import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import AnimatedPage from '../components/animatedPage'
import Banner from '../components/banner/banner'
import ScrollContainer from 'react-indiana-drag-scroll'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6'

const TabsPage = ({ title, bg, tabs }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const queryParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  )
  const scrollRef = useRef(null)
  const [isScrollable, setIsScrollable] = useState(false)

  // Function to scroll left
  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -150, behavior: 'smooth' })
    }
  }

  // Function to scroll right
  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 150, behavior: 'smooth' })
    }
  }

  // Check if content is scrollable
  useEffect(() => {
    const checkScrollable = () => {
      if (scrollRef.current) {
        const { scrollWidth, clientWidth } = scrollRef.current
        setIsScrollable(scrollWidth > clientWidth)
      }
    }

    checkScrollable()
    window.addEventListener('resize', checkScrollable)
    return () => window.removeEventListener('resize', checkScrollable)
  }, [tabs])
  const defaultActiveTab = parseInt(queryParams.get('tab')) || 0
  const [activeTab, setActiveTab] = useState(defaultActiveTab)
  const handleTabClick = index => {
    setActiveTab(index)
    queryParams.set('tab', index)
    navigate({ search: queryParams.toString() })
  }
  return (
    <AnimatedPage>
      <Banner text={title} bg={bg} />
      <div className='w-full max-w-8xl my-4 flex items-center  justify-center gap-8'>
        <div className='flex w-full items-center'>
          {/* Left Arrow Button (visible on mobile) */}
          <button
            onClick={scrollLeft}
            className='p-2 bg-white bg-opacity-80 rounded shadow-md md:hidden flex-shrink-0'
            aria-label='Scroll tabs left'
          >
            <FaChevronLeft className='text-gray-600' />
          </button>
          <ScrollContainer
            horizontal
            innerRef={scrollRef}
            className={`flex-1 flex gap-3 lg:gap-5 scroll-smooth snap-mandatory snap-x overflow-x-auto lg:scroll-px-3 mx-2 ${
              isScrollable ? 'justify-start' : 'justify-center'
            }`}
            role='tablist'
          >
            {tabs?.map((tab, index) => (
              <button
                key={index}
                className={`whitespace-nowrap shrink-0 snap-center ${
                  activeTab === index ? 'text-[#000000]' : 'text-[#747474]'
                } text-lg font-semibold border-b-4 px-4 pb-1 transition-all ${
                  activeTab === index
                    ? 'border-[#FF4D4D]'
                    : 'border-transparent'
                }`}
                onClick={() => handleTabClick(index)}
              >
                {tab.header}
              </button>
            ))}
          </ScrollContainer>
          <button
            onClick={scrollRight}
            className='p-2 bg-white bg-opacity-80 rounded shadow-md md:hidden flex-shrink-0'
            aria-label='Scroll tabs right'
          >
            <FaChevronRight className='text-gray-600' />
          </button>
        </div>
      </div>
      <div className='w-full flex items-center justify-center mb-8'>
        <div className='w-full flex items-center justify-center'>
          {tabs[activeTab]?.content}
        </div>
      </div>
    </AnimatedPage>
  )
}

export default TabsPage
